import React from 'react'

export type FooterProps = {}

export function Footer(props: FooterProps) {
  return <div></div>
}
